export default __webpack_public_path__ + "static/media/doctor.93e072f5.png";